import { ValidPhoneAuthCodeTokenResponseDto } from "@/data/dto/valid-phone-auth-code-token-response-dto";
import { resetPasswordByLinkRequestPayload } from "@/data/payload/auth/change-password-by-link-request-payload";
import { InitPasswordByLinkRequestPayload } from "@/data/payload/auth/init-password-by-lint-request-payload";
import { SendFindPasswordLinkByEmailPayload } from "@/data/payload/auth/send-find-password-link-by-email-payload";
import { ValidUserCodeRequestPayload } from "@/data/payload/auth/valid-user-auth-token-request-payload";
import { URLList } from "@/data/url_list";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";
import { IssueUserCodeRequestPayload } from "@/data/payload/auth/issue-user-code-request-payload";
import { UserAuthCodeTokenEntity } from "@/domain/entity/phone-auth-token-entity";

export class UserPasswordManageSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  async issueUserAuthCode(
    payload: IssueUserCodeRequestPayload
  ): Promise<SATResult<UserAuthCodeTokenEntity, SATError>> {
    try {
      const url = `${URLList.AUTH_CODE.URL}`;
      const response = await this.client.post(url, payload);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error(
        "[UserPasswordManageSource] :: issueUserAuthCode :: 사용자 인증 코드 발급 요청 실패",
        error
      );
      const satError = errorConverter.convertError(error);
      console.log("[UserPasswordManageSource] :: issueUserAuthCode | ", satError);
      return SATResult.failure(satError);
    }
  }

  async validUserAuthCode(
    payload: ValidUserCodeRequestPayload
  ): Promise<SATResult<ValidPhoneAuthCodeTokenResponseDto, SATError>> {
    try {
      const url = `${URLList.AUTH_CODE.URL}/${payload.token}/${payload.code}`;
      const response = await this.client.get(url);
      console.log("[AuthSource] :: validPhoneAuthCode :: 휴대폰 인증 코드 검증 요청 성공");
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[AuthSource] :: validPhoneAuthCode :: 휴대폰 인증 코드 검증 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[AuthSource] :: validPhoneAuthCode | ", satError);
      return SATResult.failure(satError);
    }
  }

  async sendEmailAuthCode(
    payload: SendFindPasswordLinkByEmailPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = URLList.AUTH_CODE.SEND_EMAIL_WITH_LINK;
      const response = await this.client.post(url, payload);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[AuthSource] :: sendEmailAuthCode :: 이메일 인증 코드 발급 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[AuthSource] :: sendEmailAuthCode | ", satError);
      return SATResult.failure(satError);
    }
  }

  async resetPasswordByLink(
    payload: resetPasswordByLinkRequestPayload
  ): Promise<SATResult<void, SATError>> {
    const newPayload = {
      newSn: payload.newSn,
    };
    try {
      const url = `${URLList.AUTH_CODE.SEND_EMAIL_WITH_LINK}/${payload.token}`;
      const response = await this.client.put(url, newPayload);
      console.log("[AuthSource] :: passwordReset :: 비밀번호 재설정 요청 성공");
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[AuthSource] :: passwordReset :: 비밀번호 재설정 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[AuthSource] :: passwordReset | ", satError);
      return SATResult.failure(satError);
    }
  }

  async setInitialPasswordByLink(
    payload: InitPasswordByLinkRequestPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.AUTH_CODE.INIT_PASSWORD}`;
      const response = await this.client.put(url, payload);
      console.log("[AuthSource] :: initPassword :: 초기 비밀번호 설정 요청 성공");
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[AuthSource] :: initPassword :: 초기 비밀번호 설정 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[AuthSource] :: initPassword | ", satError);
      return SATResult.failure(satError);
    }
  }
}
